export default __webpack_public_path__ + "static/media/tag-o.a5c485f8.svg";